import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/mail-monitor';

export default {
  getAllMailMonitors(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}${queryString}`);
  },
  createMonitor(monitor) {
    return axios.post(`${base}/create`, monitor);
  },
  deleteMonitor(id) {
    return axios.delete(`${base}/delete/${id}`);
  },
  getMonitor(prisonerNumber) {
    return axios.get(`${base}/single/${prisonerNumber}`);
  },
};
